import { CancelToken } from 'axios';

import { Http, PageData, PageQuery } from '@mygpt/app/http';

export interface ChunkSearchParams extends PageQuery {
  datasetId: string;
  fileId: string;
  query?: string;
}

export interface ChunkMetadata {
  file_id?: string;
  page_numbers?: number[];
  chunk_index: number;
  doc_id?: string;
  source: string;
  tokens: number;
  title?: string;
  outlines?: string[];
}

export interface ChunkItem {
  id: string;
  text: string;
  score: number;
  metadata: ChunkMetadata;
  dataset_id: string;
}

export const getChunksPage = (params: ChunkSearchParams, cancelToken?: CancelToken) => {
  const { datasetId, fileId, ...rest } = params;
  const { get } = Http.use();
  return get<PageData<ChunkItem>>(`/datasets/${datasetId}/files/${fileId}/chunks`, {
    params: rest,
    cancelToken,
  });
};
